import { Checkbox, Input, Form, Tag, Slider } from "antd";
import { BaseSelect } from "components/Elements";
import ServiceWeightRangeSettings, { weightRangeValidator } from "components/ServiceWeightRangeSettings";

export function generateBusinessPanLabel(businessType) {
	if (['1', '9'].includes(businessType)) return 'Business PAN';
	return 'Company PAN';
}

export function generateBusinessProofLabel(businessType) {
	switch (businessType) {
		case '1':
			return 'GST / MSME / Shops Establishment';
		case '2':
			return 'Partnershipd Deed';
		case '3':
			return 'COI (Certificate of Incorporation)';
		case '4':
			return 'COI (Certificate of Incorporation)';
		case '5':
			return 'COI (Certificate of Incorporation)';
		case '6':
			return 'NGO certificate';
		case '7':
			return 'Trust Certificate';
		case '8':
			return 'Society Certificate';
		default:
			return 'Business Proof Document';
	}
}

export const ORDERTYPE = {
	total_records: 'All Orders',
	unpaid_records: 'Not Paid : Need to be Shipped',
	paid_records: 'Paid : Need to be Shipped',
	fulfillment_processing_records: 'Fulfilment in Process',
};

export function generateFormElement(field) {
	if (field.type === 'hidden') return null;

	let element = <Input />;
	if (field.type === 'textarea') element = <Input.TextArea />;
	else if (field.type === 'select') element = <BaseSelect options={field.options} optionLabel='label' optionValue='value' defaultText="Select one" />
	else if (field.type === 'multi-select') element = <BaseSelect options={field.options} optionLabel='label' optionValue='value' defaultValue={[]} mode="multiple" />
	else if (field.type === 'checkbox') element = <Checkbox.Group options={field.options} />;
	else if (field.type === 'range') element = <Slider range min={field.min ?? 0} max={field.max ?? 100} step={field.step ?? 1} defaultValue={[field.min, field.max]} tooltip={{ open: true }} />;
	else if (field.type === 'weight-range-settings') element = <ServiceWeightRangeSettings options={field.options} />;

    const rules = [{ required: field.is_required }];
    if (field.type === 'weight-range-settings') {
        rules.push({ validator: weightRangeValidator });
    }

	return (
		<Form.Item name={field.name} label={field.label} extra={field.description} rules={rules}>
			{element}
		</Form.Item>
	)
}

export function generateShipmentTrackingUrl(serviceId, trackingNumber) {
	switch (serviceId) {
		case 7: return {
			url: `https://shiprocket.co/tracking/${trackingNumber}`,
			type: 'embedded'
		};
		case 9: return {
			url: `https://www.pickrr.com/tracking/#/?tracking_id=${trackingNumber}`,
			type: 'embedded'
		};
		case 21: return {
			url: `https://ship.nimbuspost.com/shipping/tracking/${trackingNumber}`,
			type: 'redirect'
		};
		case 24: return {
			url: `https://attracking.postnord.com/fi/?id=${trackingNumber}`, // staging env
			type: 'embedded'
		};
		default: return {
			url: null,
			type: 'embedded'
		};
	}
}

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export function generateDomainStatus(status) {
	switch (status) {
		case 0:
			return <Tag color="default">unset</Tag>;
		case 1:
			return <Tag color="warning">pending</Tag>;
		case 2:
			return <Tag color="success">verified</Tag>;
		case 3:
			return <Tag color="purple">success</Tag>;
		default:
			return <Tag color="default">undefined</Tag>;
	}
}

export function generateServiceName(services, serviceId) {
	const selectedService = services.find(service => Number(service.id) === Number(serviceId));

	if (selectedService) return selectedService.display;

	return null;
}

export function generateShipmentStatus(status) {
	switch (status) {
		case 0:
			return <Tag color="default">Pending</Tag>;
		case 1:
			return <Tag color="blue">Booked</Tag>;
		case 2:
			return <Tag color="purple">Picked Up</Tag>;
		case 3:
			return <Tag color="purple">In Transit</Tag>;
		case 4:
			return <Tag color="volcano">Exception</Tag>;
		case 5:
			return <Tag color="cyan">Out for Delivery</Tag>;
		case 6:
			return <Tag color="cyan">Out for Pickup</Tag>;
		case 7:
			return <Tag color="lime">Returned</Tag>;
		case 8:
			return <Tag color="green">Delivered</Tag>;
		case 9:
			return <Tag color="red">Cancelled</Tag>;
		case 9:
			return <Tag color="red">Unprocessed</Tag>;
		default:
			return null;
	}
}	
